<template>
  <div v-if="!accepted" class="Cookie" :class="`Cookie--${theme}`">
    <div class="Cookie__content">
      <slot name="message">
        <p>{{ defaultMessage }}</p>
      </slot>
    </div>
    <div class="Cookie__buttons">
      <button class="Cookie__button" @click="accept">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieLaw',
  props: {
    theme: { type: String, default: 'default' },
    buttonText: { type: String, default: 'OK' },
    storageKey: { type: String, default: 'cookie:consent' },
    expiresDays: { type: Number, default: 365 }, // reserved if you want cookie expiry later
  },
  data() {
    return { accepted: false }
  },
  computed: {
    defaultMessage() {
      return 'We use cookies to improve your experience.'
    },
  },
  created() {
    this.accepted = localStorage.getItem(this.storageKey) === '1'
  },
  methods: {
    accept() {
      localStorage.setItem(this.storageKey, '1')
      this.accepted = true
      this.$emit('accept')
    },
  },
}
</script>

<style scoped>
/* minimal layout; your existing .Cookie--portal styles in Home.vue will still apply */
.Cookie {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 100%;
    @media (max-width: 767px) {
        flex-direction: column;
        align-items: center;
    }
}

.Cookie__buttons {
    display: flex;
}

.Cookie__button {
    cursor: pointer;
    padding: 10px 35px;
    margin: 0 .9375rem;
}
</style>
